module.exports = __webpack_public_path__ + "falkland-islands.svg?b4efb2a344746ed66570123fb23d81c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/falkland-islands.svg
// module id = 163
// module chunks = 10